import React, { useState } from "react";

const CommonFiltersUtils = () => {
  const [showProfilemodal, setShowProfileModal] = useState(false);
  const handleCloseProfilemodal = () => setShowProfileModal(false);
  const handleShowProfilemodal = () => setShowProfileModal(true);

  return {
    showProfilemodal,
    setShowProfileModal,
    handleCloseProfilemodal,
    handleShowProfilemodal,
  };
};

export default CommonFiltersUtils;
